"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRawDataMappersResponseAllOfToJSON = exports.GetRawDataMappersResponseAllOfFromJSONTyped = exports.GetRawDataMappersResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetRawDataMappersResponseAllOfFromJSON(json) {
    return GetRawDataMappersResponseAllOfFromJSONTyped(json, false);
}
exports.GetRawDataMappersResponseAllOfFromJSON = GetRawDataMappersResponseAllOfFromJSON;
function GetRawDataMappersResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rawDataMappers': (json['rawDataMappers'].map(_1.RawDataMapperFromJSON)),
    };
}
exports.GetRawDataMappersResponseAllOfFromJSONTyped = GetRawDataMappersResponseAllOfFromJSONTyped;
function GetRawDataMappersResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rawDataMappers': (value.rawDataMappers.map(_1.RawDataMapperToJSON)),
    };
}
exports.GetRawDataMappersResponseAllOfToJSON = GetRawDataMappersResponseAllOfToJSON;
